import AppFooter from "Layout/AppFooter";
import PageHeading from "Layout/AppMain/PageHeading";
import React, { Fragment, useEffect, useState } from "react";
import Default from "../WeekReportInfo/Partials";
import { useLocation } from "react-router";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { useNavigate } from "react-router-dom";
import { useGetWeekstaatData } from "Api/Coordinator/Weekstaten";

const WeeklyStatements = () => {
    const [showLoader, setShowLoader] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);

    const location = useLocation();
    const navigate = useNavigate();

    const processData = location.state?.data;

    const body = {
        id: processData?.iWeekstaatId,
        wid: processData?.wid,
        sid: processData?.iSchoolId,
    };

    const {
        trigger: getWeekstaatDataTrigger,
        data: weekstaatResponse,
    } = useGetWeekstaatData();

    const weekReportData = weekstaatResponse?.data;

    useEffect(() => {
        if (!processData) return;

        setShowLoader(true);

        getWeekstaatDataTrigger({
            data: body
        }).catch((error) => {
            console.error(error);
            setShowLoader(false);
        });
    }, [processData]);

    useEffect(() => {
        if (weekstaatResponse) {
            setShowLoader(false);
        }
    }, [weekstaatResponse]);

    useEffect(() => {
        if (
            weekstaatResponse?.status === false &&
            weekstaatResponse?.error === "invalid_link"
        ) {
            navigate("/no-page-found");
        }
    }, [weekstaatResponse, navigate]);

    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                <Fragment>
                    <Default
                        setCurrentIndex={setCurrentIndex}
                        currentIndex={currentIndex}
                        weekReportData={weekReportData}
                        showLoader={showLoader}
                        mutateWeekReport={() =>
                            getWeekstaatDataTrigger({
                                data: body
                            })
                        }
                    />
                </Fragment>
            </TransitionOnLoad>
            {/* <AppFooter /> */}
        </Fragment>
    );
};

export default WeeklyStatements;